import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Button, IconButton, Drawer, List, ListItemButton, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import wallpaper from '../assets/pink_and_cream.png';
import wallpaper2 from '../assets/home-next-episode.gif';

interface HeaderProps {
  scrollToSection: (id: string) => void;
}

const Header: React.FC<HeaderProps> = ({ scrollToSection }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setIsDrawerOpen(open);
  };

  const buttonStyles = {
    color: '#333',
    fontWeight: 'bold', // 視認性を上げるために太字を維持
    fontSize: '17px', // 15pxから17pxにアップ
    textTransform: 'none',
    letterSpacing: '0.05em', // ほどよい高級感
    position: 'relative',
    fontFamily: "'Noto Serif JP', serif",
    mx: 1.2,
    transition: 'all 0.3s ease', // 全体の動きを滑らかに
    backgroundColor: 'transparent',

    '&:hover': {
      backgroundColor: 'transparent',
      transform: 'translateY(-2px)', // 👈 わずかに上に浮くアニメーション
      color: '#000',
      '&::after': {
        width: '100%',
      },
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -2,
      left: 0,
      width: 0,
      height: '2px', // 線が細すぎると見えないので2pxに
      backgroundColor: '#5AFF19',
      transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{backgroundColor: '#edebeb', boxShadow: 'none'}}>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" component="div">
            <Button onClick={() => scrollToSection('section1')} sx={{ color: 'black' }}>
              <img 
                src={wallpaper2}
                alt="NextEpisode" // GIFの説明
                style={{ height: '70px' }} // ボタンに合わせてサイズ調整
              />
            </Button>
          </Typography>

          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton onClick={toggleDrawer(true)} sx={{ color: 'black' }}>
              <FontAwesomeIcon icon={faBars} />
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
            <Button onClick={() => scrollToSection('section2')} sx={buttonStyles}>
              事業内容
            </Button>
            <Button onClick={() => scrollToSection('section3')} sx={buttonStyles}>
              代表挨拶
            </Button>
            <Button onClick={() => scrollToSection('section4')} sx={buttonStyles}>
              会社概要
            </Button>
            <Button onClick={() => scrollToSection('section5')} sx={buttonStyles}>
              採用
            </Button>
            <Button onClick={() => scrollToSection('section6')} sx={buttonStyles}>
              お問い合わせ
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: 250, // Drawer の幅
            height: "100vh", // 高さを全画面
            backgroundImage: `url(${wallpaper})`, // 背景画像
            backgroundSize: "cover", // 背景を全体にカバー
            backgroundRepeat: "no-repeat", // 背景画像の繰り返しを防ぐ
            backgroundPosition: "center", // 背景画像を中央に配置
            padding: 2, // 内側の余白
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            <ListItemButton onClick={() => scrollToSection("section2")}>
              <ListItemText primary="事業内容" />
            </ListItemButton>
            <ListItemButton onClick={() => scrollToSection("section3")}>
              <ListItemText primary="代表挨拶" />
            </ListItemButton>
            <ListItemButton onClick={() => scrollToSection("section4")}>
              <ListItemText primary="会社概要" />
            </ListItemButton>
            <ListItemButton onClick={() => scrollToSection("section5")}>
              <ListItemText primary="採用" />
            </ListItemButton>
            <ListItemButton onClick={() => scrollToSection("section6")}>
              <ListItemText primary="お問い合わせ" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Header;
